var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full px-2"},[_c('p',{staticClass:"my-4 mx-auto max-w-sm text-lg text-dark text-center"},[_vm._v("We’ll show your business info at the end of feedback sessions, so customers know how to reach you.")]),_c('img',{staticClass:"block w-full w-118 md:w-200 mx-auto",attrs:{"src":require("@/assets/images/feedbackdone.png")}})])
}]

export { render, staticRenderFns }